export const environment = {
  production: true,
  buildId: '3299581544621251',
  configFile: 'config.json',
};
